export const getBoxShadow = ({ $hasError, $isFocus, theme, }) => [
    $isFocus
        ? theme.input.focus.borderColor
        : $hasError
            ? theme.input.error.borderColor
            : theme.input.borderColor,
    '0 0 0 1px inset !important',
].join(' ');
//# sourceMappingURL=getBoxShadow.js.map